// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: 130px;
        max-height: 110px;
        display: flex;
        ${screen("lte", "md")} {
            max-width: 105px;
        }
    `,
};
